<!-- <app-title-header 
  [title]='_title' 
  [subtitle]='_subtitle'>
</app-title-header>
<br> -->

<div class="videoconsulta"> <!-- no responsive -->
  <div class="row" style="margin: 20px 0px;">
    <div class="col-md-4 col-sm-12">
      <app-title-header [title]='_title' [subtitle]='_subtitle'>
      </app-title-header>
    </div>
    <div class="col-md-8 col-sm-12 container-buttons">

      <div class="col-md-4 sm-12" style="margin-bottom: 5px;">
        <button *ngIf="anulacionConsulta" type="button" class="btn botonCancelar colorLetraVolver" data-toggle="modal"
          tabindex="-1" (click)="abrirModal('cancelarPendiente')"> Anular consulta</button>
      </div>
      <div class="col-md-4 sm-12" style="margin-bottom: 5px;">
        <button *ngIf="!videoIniciado" type="button" class="btn btn-secondary botonVolver" data-toggle="modal"
           [disabled]="(btnIniciar == false)" (click)="iniciarVideoconsulta()" >Iniciar videollamada
        </button>
        <button *ngIf="videoIniciado" type="button" class="btn botonCancelar colorLetraVolver"
          (click)='finalizarVideoconsulta();endMeeting()'>Finalizar videollamada
        </button>
      </div>

    </div>
  </div>


  <div class="row">

    <div class="col-md-4 col-sm-12">

      <div class="detalle-consulta">
        <h4 style="margin-bottom: 10px;">Hoy {{consulta.fecha_consulta.day}} de {{consulta.fecha_consulta.month}} - a
          las {{consulta.fecha_consulta.time}} horas</h4>
        <div class="align-self-center">
          <p class="card-text m-0 p-0">Paciente: {{consulta.nombre_paciente}} {{consulta.apellido_paterno_paciente}}
            {{consulta.apellido_materno_paciente}}</p>
          <p class="card-text m-0 p-0 ">Edad: {{consulta.edad}}</p>
          <p class="card-text m-0 p-0">Acompañante: {{consulta.nombre_acompanante}}
            {{consulta.apellido_paterno_acompanante}} {{consulta.apellido_materno_acompanante}}</p>
          <p class="card-text m-0 p-0">Área médica: {{consulta.spe_name}} </p>
        </div>
        <h4 style="margin: 12px 0">Motivo de consulta</h4>
        <div class="align-self-center">
          <p class="card-text m-0 p-0" style="padding: 10px auto;">{{consulta.razon}}</p>
        </div>
      </div>

      <div class="card border-confirm card-fono">
        <div class="card-block ">
          <p class="card-text m-0 p-0">Si tienes algún problema técnico, o el paciente no se presenta, debes comunicarte
            con nuestra Mesa de Ayuda.</p>
          <p *ngIf="consulta.telefono_plan" class="fono p-0">{{consulta.telefono_plan}}</p>
        </div>
      </div>

    </div>

    <div class="col-md-8 col-sm-12" style="height: fit-content;">

      <app-video-web-rtc [video_iniciado]='videoIniciado'>
      </app-video-web-rtc>
    </div>
  </div>

</div>

<div class="options">
  <div class="row" style="margin: 0;">
    <button class="col-md-3 col-sm-6" id="consulta" [class]="options[0] ? 'checked' : 'nochecked'"
      (click)="optionsButton(0)">Consulta actual y documentos</button>
    <button class="col-md-3 col-sm-6" [class]="options[1] ? 'checked' : 'nochecked'"
      (click)="optionsButton(1)">Antecedentes del paciente</button>
    <button class="col-md-3 col-sm-6" [class]="options[2] ? 'checked' : 'nochecked'"
      (click)="optionsButton(2)">Consultas previas del paciente</button>
    <button class="col-md-3 col-sm-6" id="agenda" [class]="options[3] ? 'checked' : 'nochecked'"
      (click)="optionsButton(3)">Mi agenda</button>
  </div>
</div>



<div *ngIf="options[0]">
  <app-ficha-medica [eventos]='ficha_eventos' [consulta]='consulta'>
  </app-ficha-medica>
</div>


<div *ngIf="options[1]">
  <app-antecedentes-paciente [consulta]='consulta'>
  </app-antecedentes-paciente>
</div>

<div *ngIf="options[2]">
  <app-consultas-previas [consulta]='consulta'>
  </app-consultas-previas>
</div>



<div style="margin-left: 5px;" id="agenda_medico" style="display: none;">
  <app-agenda-medico2 class="" (messageEvent)='clickHourAgendaMedico($event)'>
  </app-agenda-medico2>
</div>

<!-- MODAL INSTRUCCIONES ANTES DE VIDEOLLAMADA -->

<ng-template #modalInstruccionesTpl>

    <div style="overflow: auto;">
      <div class="modal-instrucciones-doctor-contenido" (click)="$event.stopPropagation()">
        <h4 class="tituloModalConfirmar">
          <span class="emoji">🔔</span>
          <span class="texto">Antes de comenzar tu videollamada</span>
        </h4>
    
        <p class="descripcionModal">
          Para asegurar una atención médica sin interrupciones, te pedimos <strong>verificar lo siguiente:</strong>
        </p>
        <div class="listaModal">
          <div class="itemModal">📶 Contar con una conexión a Internet rápida y estable.</div>
          <div class="itemModal">🎥 Permitir el uso de cámara y micrófono en tu navegador.</div>
          <div class="itemModal">🌐 Usar Google Chrome como navegador.</div>
        </div>
        <p class="descripcionModal">
          Por favor considera que <strong>la videollamada no funcionará</strong> en caso de:
        </p>
        <div class="listaModal">
          <div class="itemModal">🚫 Hacer uso de equipos corporativos que usen VPN o cuenten con bloqueos de seguridad de video/audio.</div>
        </div>
    
        <div class="footerModal">
          <div class="checkModal">
            <input class="form-check-input" type="checkbox" id="aceptar" [(ngModel)]="aceptoInstrucciones" />
            <label for="aceptar">No volver a mostrar este mensaje.</label>
          </div>
    
          <button class="btnContinuar" (click)="iniciarVideoconsulta()">Continuar</button>
        </div>
      </div>}
      
</div>
</ng-template>


<!-- Modal Anulacion consulta -->

<!-- MODAL CONFIRMACIÓN PRINCIPAL -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'cancelarPendiente'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Deseas anular esta consulta?</h2>
    <p class="modal-reason">
      Al hacerlo, se notificará al paciente y la consulta quedará anulada. </p>
    <p class="modal-reason2">Selecciona el motivo de anulación:</p>

    <form [formGroup]="anularReservaForm" novalidate>
      <div class="form-group">
        <select class="form-control" formControlName="motivo">
          <option value="" disabled selected>Selecciona un motivo</option>
          <option *ngFor="let razon of cancelReason" [value]="razon.id_reason">
            {{ razon.reason_name }}
          </option>
        </select>
        <small class="text-danger"
          *ngIf="anularReservaForm.get('motivo')?.invalid && anularReservaForm.get('motivo')?.touched">
          Debes seleccionar un motivo.
        </small>
      </div>
    </form>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()">
          <p class="m-0" style="font-weight: 600;">Volver</p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" [disabled]="anularReservaForm.invalid"
          (click)="mostrarModalConfirmacion()">
          <p class="m-0" style="font-weight: 600;">Anular consulta</p>
        </button>
      </div>
    </div>
  </div>
</div>



<!-- MODAL CONFIRMACIÓN PRINCIPAL -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'cancelarPendiente'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Deseas anular esta consulta?</h2>
    
    <p class="modal-reason2">Selecciona el motivo de anulación:</p>
 
    <form [formGroup]="anularReservaForm" novalidate>
      <div class="form-group">
        <select class="form-control" formControlName="motivo">
          <option value="" disabled selected>Selecciona un motivo</option>
          <option *ngFor="let razon of cancelReason" [value]="razon.id_reason">
            {{ razon.reason_name }}
          </option>
        </select>
        <small class="text-danger" *ngIf="anularReservaForm.get('motivo')?.invalid && anularReservaForm.get('motivo')?.touched">
          Debes seleccionar un motivo.
        </small>
      </div>
    </form>
 
    <div class="buttons-box row mt-3">
      <div class="col">
        <button class="btn-secondary-anular botonCancelar" style="line-height: 36px;" (click)="cerrarModal()">
          Volver
        </button>
      </div>
      <div class="col text-right">
        <button class="btn-primary-cancel botonCancelar" (click)="mostrarModalConfirmacion()">
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>
 
<!-- SEGUNDO MODAL DE CONFIRMACIÓN FINAL -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmacionFinalPendiente'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">Confirmación de anulación</h2>
    <p class="modal-reason">
      Al confirmar esta acción, el paciente será notificado de la anulación. </p>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()">
          <p class="m-0" style="font-weight: 600;">Cancelar</p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" (click)="anularReservaConfirmada()">
          <p class="m-0" style="font-weight: 600;">Confirmar anulación</p>
        </button>
      </div>
    </div>
  </div>
</div>